import { render, staticRenderFns } from "./RegisterFormLocalFinalStep.vue?vue&type=template&id=1b72f978&scoped=true&"
import script from "./RegisterFormLocalFinalStep.vue?vue&type=script&lang=js&"
export * from "./RegisterFormLocalFinalStep.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormLocalFinalStep.vue?vue&type=style&index=0&id=1b72f978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72f978",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSelect: require('/workspace/components/Form/FormSelect.vue').default,FormInput: require('/workspace/components/Form/FormInput.vue').default,FormInputPassword: require('/workspace/components/Form/FormInputPassword.vue').default,FormInput: require('/workspace/components/Form/FormInput.vue').default,FormCheckBox: require('/workspace/components/Form/FormCheckBox.vue').default,Form: require('/workspace/components/Form/index.js').default})
